import ProductPlaceholderImage from '../Assets/img/placeholder.svg';

// function to render fallback image
const addDefaultImgSrc = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = ProductPlaceholderImage;
}


export { addDefaultImgSrc }
